import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../api.js'
import { useSitzung } from '../sitzung.jsx'
import Icon from '../Icon.jsx'

const MINDESTLAENGE = 10

export default function Einrichten() {
  const { token } = useParams()
  const navigate = useNavigate()
  const { neuAnmelden } = useSitzung()

  const [konto, setKonto] = useState(null)
  const [linkFehler, setLinkFehler] = useState('')
  const [passwort, setPasswort] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [fehler, setFehler] = useState('')
  const [sendet, setSendet] = useState(false)

  // Zuerst klaeren, ob der Link ueberhaupt gilt — und fuer wen. Sonst tippt
  // jemand ein Passwort in ein Formular, das ihn danach abweist.
  useEffect(() => {
    let abgebrochen = false
    api(`/einrichtung/${encodeURIComponent(token)}`)
      .then((daten) => {
        if (!abgebrochen) setKonto(daten)
      })
      .catch((e) => {
        if (!abgebrochen) setLinkFehler(e.message)
      })
    return () => {
      abgebrochen = true
    }
  }, [token])

  async function absenden(ereignis) {
    ereignis.preventDefault()
    if (passwort !== wiederholung) {
      setFehler('Die beiden Eingaben stimmen nicht überein.')
      return
    }
    setFehler('')
    setSendet(true)
    try {
      const daten = await api(`/einrichtung/${encodeURIComponent(token)}`, {
        methode: 'POST',
        koerper: { passwort },
      })
      // Der Server hat die Sitzung schon gesetzt — nur noch übernehmen.
      neuAnmelden(daten.benutzer)
      navigate('/', { replace: true })
    } catch (e) {
      setFehler(e.message)
      setSendet(false)
    }
  }

  if (linkFehler) {
    return (
      <main className="huelle huelle--schmal">
        <h1>Stundenzettel</h1>
        <section className="karte">
          <h2>Link nicht verwendbar</h2>
          <div className="meldung fehler">
            <Icon name="warnung" groesse={18} />
            <span>{linkFehler}</span>
          </div>
          <p className="hinweis">
            Bitte bei der Verwaltung einen neuen Einrichtungslink anfordern.
          </p>
        </section>
      </main>
    )
  }

  if (!konto) {
    return (
      <main className="huelle huelle--schmal">
        <p className="hinweis">Einen Moment …</p>
      </main>
    )
  }

  const zuKurz = passwort.length > 0 && passwort.length < MINDESTLAENGE

  return (
    <main className="huelle huelle--schmal">
      <h1>Stundenzettel</h1>
      <p className="untertitel">
        {konto.zweck === 'zuruecksetzen' ? 'Neues Passwort für ' : 'Willkommen, '}
        {konto.name}.
      </p>

      <form className="karte" onSubmit={absenden}>
        <p className="hinweis hinweis--oben">
          Konto <strong>{konto.email}</strong>
        </p>

        <div className="feld">
          <label htmlFor="passwort">Passwort wählen</label>
          <input
            id="passwort"
            type="password"
            autoComplete="new-password"
            required
            autoFocus
            minLength={MINDESTLAENGE}
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
          />
          <p className={`hinweis ${zuKurz ? 'fehler' : ''}`}>
            Mindestens {MINDESTLAENGE} Zeichen. Länge zählt mehr als Sonderzeichen.
          </p>
        </div>

        <div className="feld">
          <label htmlFor="wiederholung">Passwort wiederholen</label>
          <input
            id="wiederholung"
            type="password"
            autoComplete="new-password"
            required
            value={wiederholung}
            onChange={(e) => setWiederholung(e.target.value)}
          />
        </div>

        {fehler && (
          <div className="meldung fehler" role="alert">
            <Icon name="warnung" groesse={18} />
            <span>{fehler}</span>
          </div>
        )}

        <button className="knopf knopf--haupt knopf--breit" type="submit" disabled={sendet}>
          <Icon name="schloss" /> {sendet ? 'Wird gespeichert …' : 'Passwort speichern'}
        </button>
      </form>
    </main>
  )
}
